import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class EventService {

  // Observable string sources
  private eventSenderSource = new Subject<string>();
  // private eventReceiverSource = new Subject<string>();

  // Observable string streams
  eventSenderSource$ = this.eventSenderSource.asObservable();
  // eventReceiverSource$ = this.eventReceiverSource.asObservable();

  // Service message commands
  eventFromSender() {
    this.eventSenderSource.next();
  }

  // eventFromParent() {
  //   this.eventReceiverSource.next();
  // }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/shared/event.service.ts